import React from "react";

function XIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#1C1C1B"
        d="M24.623 12.659c0 6.062-4.492 11.074-10.328 11.887a12.157 12.157 0 01-3.593-.038C4.99 23.588.625 18.633.625 12.658c0-6.628 5.373-12.003 12-12.003s12 5.375 12 12.004h-.002z"
      ></path>
      <path
        fill="#fff"
        d="M5.492 5.95l5.534 7.4-5.569 6.018h1.254l4.875-5.268 3.94 5.268h4.265l-5.845-7.817 5.183-5.602h-1.253l-4.49 4.852L9.758 5.95H5.492zm1.843.923h1.959l8.652 11.572h-1.959L7.335 6.873z"
      ></path>
    </svg>
  );
}

export default XIcon;
